// @ts-nocheck
import React from 'react';
import { ShippingCalculator } from './components/ShippingCalculator';

const App: React.FC = () => {
  // Get URL parameters for customization
  const urlParams = new URLSearchParams(window.location.search);
  const blurBackground = urlParams.get('blurBackground') === 'true';
  const transparentBox = urlParams.get('transparentBox') === 'true';
  const primaryColor = urlParams.get('primaryColor') || '#00ff08';
  const buttonFontColor = urlParams.get('buttonFontColor') || '#000';
  const accentColor = urlParams.get('accentColor') || '#0066cc';
  const labelColor = urlParams.get('labelColor') || '#374151';
  const borderRadius = urlParams.get('borderRadius') || 'rounded-lg';
  const iframeKey = urlParams.get('iframe_key') || '0ß23045ß90ß29fsyx24ß91';
  const badgeActiveColor = urlParams.get('badgeActiveColor') || primaryColor; // Default to primary color
  const showInternational = urlParams.get('showInternational') !== 'false'; // Default to true, only false if explicitly set
  const isCarrier = urlParams.get('isCarrier') === 'true'; // Default to false
  const carrierId = urlParams.get('carrierId')|| null;; // Default to false
  // Get language from URL parameter or detect from parent URL
  let language = urlParams.get('language') as 'de' | 'en' | 'it' | 'fr' | undefined;
  
  // If no language parameter, try to detect from parent URL path
  if (!language && window.self !== window.top) {
    try {
      const parentUrl = window.parent.location.href;
      // Check for language patterns in the parent URL
      if (parentUrl.includes('/it/') || parentUrl.includes('/richiesta')) {
        language = 'it';
      } else if (parentUrl.includes('/fr/') || parentUrl.includes('/demande-expedition')) {
        language = 'fr';
      } else if (parentUrl.includes('/en/') || parentUrl.includes('/shipment-request')) {
        language = 'en';
      } else {
        language = 'de'; // Default to German
      }
    } catch (e) {
      // If we can't access parent URL due to cross-origin, default to German
      console.log('Could not access parent URL, defaulting to German');
      language = 'de';
    }
  } else if (!language) {
    // Not in iframe or no language specified, default to German
    language = 'de';
  }
  
  return (
    <div>
      {/* The shipping calculator component */}
      <ShippingCalculator
        blurBackground={blurBackground}
        transparentBox={transparentBox}
        primaryColor={primaryColor}
        buttonFontColor={buttonFontColor}
        accentColor={accentColor}
        labelColor={labelColor}
        borderRadius={borderRadius}
        iframeKey={iframeKey}
        badgeActiveColor={badgeActiveColor}
        showInternational={showInternational}
        isCarrier={isCarrier}
        carrierId={carrierId}
        language={language}
      />
    </div>
  );
};

export default App;